import React, { useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import 'animate.css';

const ScrollAnimation = ({ children, animation }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const animationRef = useRef(null);

  const handleAnimation = () => {
    if (inView) {
      animationRef.current.classList.add('animate__animated', `animate__${animation}`);
    } else {
      animationRef.current.classList.remove('animate__animated', `animate__${animation}`);
    }
  };

  return (
    <div ref={ref} className="scroll-animation" onScroll={handleAnimation}>
      <div ref={animationRef}>{children}</div>
    </div>
  );
};

export default ScrollAnimation;
